/**
 * Component - expandListWithForm
 */

export const faqListControls = (faqListWrapper: HTMLElement): void => {
  const itemList = faqListWrapper.querySelectorAll('.js-expandListWithForm-singleControl') as unknown as HTMLElement[]

  itemList.forEach(single => {
    single.addEventListener('click', () => {
      const windowWidth = window.innerWidth
      const wrapper = single.closest('.js-expandListWithForm-singleWrapper') as unknown as HTMLElement

      // Wasnt quite sure how to name these... all countdowns for animations
      const timeoutCounter = (windowWidth >= 768) ? 300 : 600
      const timeoutSmallCounter = (windowWidth >= 768) ? 250 : 500
      const timeoutSmallestCounter = (windowWidth >= 768) ? 50 : 100

      // If the element is animating, kill the script and wait
      if (wrapper.classList.contains('-animating')) {
        return
      }

      // Add animation lock
      wrapper.classList.add('-animating')

      // Do a basing selection and set current max height for smooth animation
      const contentWrapper = wrapper.querySelector('.js-expandListWithForm-singleContentWrapper') as unknown as HTMLElement
      const content = wrapper.querySelector('.js-expandListWithForm-singleContent') as unknown as HTMLElement
      const contentHeight = content.clientHeight
      contentWrapper.style.maxHeight = `${contentHeight}px`

      // Opening & Closing
      if (wrapper.classList.contains('-closed')) {
        // Open
        wrapper.classList.remove('-elipsis')

        // Wait before animation to avoid glitching and let DOM update first
        setTimeout(() => {
          const contentHeight = content.clientHeight
          contentWrapper.style.maxHeight = `${contentHeight}px`
          // Wait for animation
          setTimeout(() => {
            wrapper.classList.remove('-closed')
            contentWrapper.style.removeProperty('max-height')
            wrapper.classList.remove('-animating')
          }, timeoutCounter)
        }, timeoutSmallestCounter)
      }
      else {
        // Close
        const contentWrapper = wrapper.querySelector('.js-expandListWithForm-singleContentWrapper') as unknown as HTMLElement

        // Wait before animation to avoid glitching and let DOM update first
        setTimeout(() => {
          contentWrapper.style.maxHeight = (window.innerWidth > 991) ? '35px' : '35px'

          // Wait for animation
          setTimeout(() => {
            wrapper.classList.add('-closed')
            wrapper.classList.add('-elipsis')
            wrapper.classList.remove('-animating')
          }, timeoutSmallCounter)
        }, timeoutSmallestCounter)
      }
    })
  })
}

export const expandListWithForm = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-expandListWithForm') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
    faqListControls(component)
  })
}
